import styles from "./OverviewSubTab.module.scss"

type Props = {
	billingEmails: string[]
}

const BillingEmailsSection = ({ billingEmails }: Props) => {
	return (
		<div className={styles.section}>
			<h3 className={styles.section_title}>明細・請求書送付先メールアドレス</h3>
			{billingEmails.length > 0 ? (
				<div className={styles.email_badges}>
					{billingEmails.map((email) => (
						<span key={email} className={styles.email_badge}>
							{email}
						</span>
					))}
				</div>
			) : (
				<p className={styles.empty_text}>登録なし</p>
			)}
		</div>
	)
}

export default BillingEmailsSection
